export const SET_CASH_PAYMENT = "SET_CASH_PAYMENT";
export const SET_SPECIFIC_CASH_PAYMENT = "SET_SPECIFIC_CASH_PAYMENT";
export const RESET_SPECIFIC_PAYMENT = "RESET_SPECIFIC_PAYMENT";